import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { Country } from "../../../utils/apis/master/Master";
import JoditEditor from "jodit-react";
library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, Select2Data } = useContext(Context);

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const {
    control,
    register,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm();

  const [videoFile, setVideoFile] = useState(null);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("content", data?.content);
      DataToSend.append("video", data.video[0]);
      DataToSend.append("type_id", data?.type_id?.value);
      const response = await postData(`/admin/setting/about-us`, DataToSend);

      if (response?.success) {
        await setShowModal({ code: response.code, message: response?.data });
      } else {
        await setShowModal({ code: response?.code, message: response?.errors });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const [types, setTypes] = useState([]);

  const handleVideoChange = (e) => {
    const file = e.target.files?.[0];

    if (file) {
      setVideoFile(URL.createObjectURL(file));
    } else {
      setVideoFile(null);
    }
  };

  const getAllTypes = async () => {
    const response = await getData(`/common/masters/all-types`);
    if (response?.success) {
      setTypes(await Select2Data(response?.data, "type_id"));
    }
  };

  useEffect(() => {
    getAllTypes();
  }, []);

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add About Us
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            onSubmit={handleSubmit(onSubmit)}
            role="form"
            // className="stateclass"
          >
            <Row>
              {/* Type Dropdown */}

              <Col md={12}>
                <Form.Label>Type</Form.Label>
                <Controller
                  className="select-contoller"
                  name={`type_id`} // name of the field
                  control={control}
                  rules={{
                    required: "Select Type",
                  }}
                  render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Select
                      styles={{
                        control: (baseStyles) => ({
                          ...baseStyles,
                          borderColor: errors?.type_id
                            ? "red"
                            : baseStyles.borderColor,
                        }),
                      }}
                      // {...field}
                      options={types}
                      onChange={(selectedValue) => {
                        onChange(selectedValue);
                      }}
                      onBlur={onBlur}
                      value={value}
                      ref={ref}
                    />
                  )}
                />
                {errors.type_id && (
                  <span className="text-danger">{errors.type_id.message}</span>
                )}
              </Col>
              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Content</Form.Label>
                    <Form.Group>
                      <InputGroup>
                        <Controller
                          name="content"
                          control={control}
                          rules={{
                            required: "Content is required.",
                            // maxLength: {
                            //   value: 600,
                            //   message:
                            //     "content must be at most 600 characters long.",
                            // },
                          }} // Correct the maxLength rule
                          render={({ field: { onChange, onBlur, value } }) => (
                            <JoditEditor
                              value={value}
                              onBlur={() => {
                                onBlur();
                                trigger("content");
                              }}
                              onChange={onChange}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.content && (
                        <span className="text-danger">
                          {errors.content.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Col md={12}>
                <div className="main-form-section mt-3">
                  <Form.Label>Upload Video</Form.Label>

                  <Form.Group>
                    <Form.Control
                      type="file"
                      accept="video/*"
                      className={classNames("", {
                        "is-invalid": errors?.video,
                      })}
                      {...register("video", {
                        required: "Video is required",
                        validate: (value) => {
                          const file = value?.[0];

                          if (!file) {
                            return "Video is required";
                          }

                          if (!file.type.startsWith("video/")) {
                            return "Only video files are allowed";
                          }

                          return true;
                        },
                        onChange: (e) => {
                          const file = e.target.files?.[0];

                          if (file) {
                            setVideoFile(URL.createObjectURL(file));
                          } else {
                            setVideoFile(null);
                          }
                        },
                      })}
                    />

                    {errors.video && (
                      <span className="text-danger">
                        {errors.video.message}
                      </span>
                    )}
                  </Form.Group>
                </div>
              </Col>

              {videoFile && (
                <Col md={12}>
                  <div className="main-form-section mt-3">
                    <Form.Label>Video Preview</Form.Label>

                    <div className="image-preview-container">
                      <video
                        controls
                        preload="metadata"
                        width="100%"
                        height="350"
                        style={{
                          display: "block",
                          backgroundColor: "#000",
                          objectFit: "contain",
                        }}
                        src={videoFile}
                      >
                        Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                </Col>
              )}

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
